import { Routes } from "@angular/router";

import { ViewResourcesResolver } from "../../resolvers";

import { LoginComponent } from "./login/login.component";
import { LogOutComponent } from "./logOut/logOut.component";

export const LoginLayoutRoutes: Routes = [

  {
    path: "Login",
    component: LoginComponent,
    resolve: { resources: ViewResourcesResolver },
    data: { view: "login", components: "Global,Login" }
  },
  {
    path: 'Login/:accessToken',
    component: LoginComponent,
    resolve: { resources: ViewResourcesResolver },
    data: { view: 'login', components: 'Global,Login' }
  },
  {
    path: 'Login/:accessToken/:refreshToken',
    component: LoginComponent,
    resolve: { resources: ViewResourcesResolver },
    data: { view: 'login', components: 'Global,Login' }
  },
  {
    path: 'LogOut',
    component: LogOutComponent,
    data: { view: 'logout', components: 'Global,Login' }
  }
  // ]
  //}
];
